import { Box, Container, CssBaseline } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'

const Layout: React.FC = () => {
  return (
    <Box>
      <CssBaseline />
      <Header />
      <Container maxWidth="xl">
        <Outlet />
      </Container>
    </Box>
  )
}

export default Layout
